import {
  ActiveBundlePageType,
  ActiveBundlePageTypeKeys,
  BUNDLE_PAGE_TYPE_STORAGE_KEY,
  selectActiveBundlePageType,
  selectSharedDataActiveTimelineChronologyType,
  setActiveBundlePageType,
  useAppDispatch,
  useAppSelector,
} from '@/store';
import { classNames } from 'primereact/utils';

const BUTTONS = [
  { key: ActiveBundlePageType.LIGHT, label: 'Light Bundle' },
  { key: ActiveBundlePageType.FULL, label: 'Full Bundle' },
];

export const NumberPagesBySwitcher = ({ disabled }: { disabled?: boolean }) => {
  const dispatch = useAppDispatch();

  const activeType = useAppSelector(selectSharedDataActiveTimelineChronologyType);
  const activeBundlePageType = useAppSelector(selectActiveBundlePageType);

  const handleClick = (key: ActiveBundlePageTypeKeys) => {
    if (activeType && activeBundlePageType !== key) {
      dispatch(setActiveBundlePageType({ key: activeType, data: key }));
      localStorage.setItem(BUNDLE_PAGE_TYPE_STORAGE_KEY, key);
    }
  };

  const isLightActive = activeBundlePageType === ActiveBundlePageType.LIGHT;
  const slideStyle = {
    left: isLightActive ? '0%' : '50%',
    width: '50%',
    height: '100%',
  };

  return (
    <div
      className={classNames(
        'relative flex h-[32px] w-full overflow-hidden',
        'rounded-[4px]',
        'border-1 border-gray-200 bg-gray-50',
        {
          'pointer-events-none opacity-50': disabled,
        },
      )}
    >
      <div
        className={classNames(
          'absolute shadow-none',
          'rounded-[4px]',
          'bg-fletchers-white border-fletchers-green-500 border-1',
          'transition-all duration-300 ease-in-out',
        )}
        style={slideStyle}
      ></div>

      {BUTTONS.map((btn) => {
        const isActive = activeBundlePageType === btn.key;
        return (
          <button
            key={btn.key}
            type="button"
            onClick={() => handleClick(btn.key)}
            disabled={disabled}
            className={classNames(
              'z-10 flex-1 px-4 py-1',
              'w-28',
              'text-[14px]/[20px]',
              'rounded-[4px]',
              'transition-colors duration-200',
              isActive
                ? 'text-fletchers-green-500 font-semibold'
                : 'text-fletchers-gray-200 hover:text-fletchers-gray-250 font-normal hover:cursor-pointer',
            )}
          >
            {btn.label}
          </button>
        );
      })}
    </div>
  );
};
